// Single source of truth for prize-tier payout rates and FormX field mapping.
//
// A "cap" (nắp khoen) is worth a fixed VND amount depending on its prize tier.
// The FormX biên bản records cap counts per tier; money = caps × rate. Both the
// accountant detail page and the public DDG receipt derive money from these.
//
// Field-tier mapping prefers explicit FormX field codes (VITE_PRIZE*_FIELD_CODE);
// when unset it falls back to a label heuristic ("giải 1" / contains "2" / "3").
// The server RPC public_payout_receipt mirrors this exact classification.

export const PRIZE1_FIELD_CODE = import.meta.env.VITE_PRIZE1_FIELD_CODE as string | undefined;
export const PRIZE2_FIELD_CODE = import.meta.env.VITE_PRIZE2_FIELD_CODE as string | undefined;
export const PRIZE3_FIELD_CODE = import.meta.env.VITE_PRIZE3_FIELD_CODE as string | undefined;

// VND payout per cap, by prize tier.
export const PRIZE1_RATE = 30_000_000;
export const PRIZE2_RATE = 1_000_000;
export const PRIZE3_RATE = 10_000;

export interface PrizeCaps {
  prize1: number;
  prize2: number;
  prize3: number;
}

export interface PrizeTierMeta {
  key: keyof PrizeCaps;
  label: string;
  rate: number;
}

// Receipt row order + display names. "Giải mass" is the tier-3 label used on the
// biên bản (its FormX field is "giải Mass", classified by code PRIZE3).
export const PRIZE_TIERS: PrizeTierMeta[] = [
  { key: 'prize1', label: 'Giải nhất', rate: PRIZE1_RATE },
  { key: 'prize2', label: 'Giải hai', rate: PRIZE2_RATE },
  { key: 'prize3', label: 'Giải mass', rate: PRIZE3_RATE },
];

export interface PrizeBreakdown extends PrizeCaps {
  total: number;
}

/** Apply per-tier rates to cap counts → total VND. */
export function capsToMoney(caps: PrizeCaps): number {
  return caps.prize1 * PRIZE1_RATE + caps.prize2 * PRIZE2_RATE + caps.prize3 * PRIZE3_RATE;
}

// DDG service fee: the exchange point earns 5% of the total exchanged amount.
export const SERVICE_FEE_RATE = 0.05;

/** DDG service fee = 5% of total exchanged VND. */
export function serviceFee(totalMoney: number): number {
  return totalMoney * SERVICE_FEE_RATE;
}
